import React from 'react';

let CITY_CACHE = null;
let ZIP_CACHE = null;
const STREET_CACHE = {};

const REGION_FILE = {
  'Вінницька': 'vinnytska', 'Волинська': 'volynska', 'Дніпропетровська': 'dnipropetrovska',
  'Донецька': 'donetska', 'Житомирська': 'zhytomyrska', 'Закарпатська': 'zakarpatska',
  'Запорізька': 'zaporizka', 'Івано-Франківська': 'ivano-frankivska', 'Київська': 'kyivska',
  'Кіровоградська': 'kirovohradska', 'Луганська': 'luhanska', 'Львівська': 'lvivska',
  'Миколаївська': 'mykolaivska', 'Одеська': 'odeska', 'Полтавська': 'poltavska',
  'Рівненська': 'rivnenska', 'Сумська': 'sumska', 'Тернопільська': 'ternopilska',
  'Харківська': 'kharkivska', 'Херсонська': 'khersonska', 'Хмельницька': 'khmelnytska',
  'Черкаська': 'cherkaska', 'Чернівецька': 'chernivetska', 'Чернігівська': 'chernihivska',
};

export default function CityInput({ value, onChange, region, style, onZipFound }) {
  const [suggestions, setSuggestions] = React.useState([]);
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    if (!CITY_CACHE) {
      fetch('/assets/ua_settlements.json').then(r => r.json()).then(data => { CITY_CACHE = data; });
    }
    if (!ZIP_CACHE) {
      fetch('/assets/ua_zips.json').then(r => r.json()).then(data => { ZIP_CACHE = data; });
    }
  }, []);

  const handleChange = (e) => {
    const val = e.target.value;
    onChange(val);
    if (val.length < 2 || !CITY_CACHE) { setSuggestions([]); setShow(false); return; }
    const list = CITY_CACHE[region] || [];
    const valLower = val.toLowerCase();
    const filtered = list.filter(c => c.toLowerCase().startsWith(valLower)).slice(0, 20);
    setSuggestions(filtered);
    setShow(filtered.length > 0);
  };

  const pick = (c) => {
    onChange(c);
    setShow(false);
    setSuggestions([]);
    if (onZipFound && ZIP_CACHE && region && ZIP_CACHE[region] && ZIP_CACHE[region][c]) {
      onZipFound(ZIP_CACHE[region][c]);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <input name="no-autofill-city-field" id="no-autofill-city-field" value={value} onChange={handleChange} onBlur={() => setTimeout(() => setShow(false), 250)} placeholder={region ? "Місто або населений пункт" : "Спочатку оберіть область"} style={style} autoComplete="off" disabled={!region} />
      {show && suggestions.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#222', border: '1px solid #444', borderRadius: '6px', zIndex: 999, maxHeight: '180px', overflowY: 'auto' }}>
          {suggestions.map((c, i) => (
            <div key={i} onMouseDown={() => pick(c)}
              style={{ padding: '8px 12px', cursor: 'pointer', color: '#fff', fontSize: '14px', borderBottom: '1px solid #333' }}
              onMouseEnter={e => e.currentTarget.style.background = '#333'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >{c}</div>
          ))}
        </div>
      )}
    </div>
  );
}

export function StreetInput({ value, onChange, region, locality, style }) {
  const [suggestions, setSuggestions] = React.useState([]);
  const [show, setShow] = React.useState(false);
  const file = REGION_FILE[region];

  React.useEffect(() => {
    if (file && !STREET_CACHE[file]) {
      fetch(`/assets/streets/${file}.json`).then(r => r.json()).then(data => { STREET_CACHE[file] = data; });
    }
  }, [file]);

  const handleChange = (e) => {
    const val = e.target.value;
    onChange(val);
    const data = STREET_CACHE[file];
    if (val.length < 2 || !data || !locality) { setSuggestions([]); setShow(false); return; }
    const list = data[locality] || [];
    const valLower = val.toLowerCase();
    const filtered = list.filter(s => s.toLowerCase().includes(valLower)).slice(0, 20);
    setSuggestions(filtered);
    setShow(filtered.length > 0);
  };

  return (
    <div style={{ position: 'relative' }}>
      <input name="no-autofill-street-field" id="no-autofill-street-field" value={value} onChange={handleChange} onBlur={() => setTimeout(() => setShow(false), 250)} placeholder={locality ? "вул. Назва" : "Спочатку введіть місто/село"} style={style} autoComplete="off" />
      {show && suggestions.length > 0 && (
        <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#222', border: '1px solid #444', borderRadius: '6px', zIndex: 999, maxHeight: '180px', overflowY: 'auto' }}>
          {suggestions.map((c, i) => (
            <div key={i} onMouseDown={() => { onChange(c); setShow(false); setSuggestions([]); }}
              style={{ padding: '8px 12px', cursor: 'pointer', color: '#fff', fontSize: '14px', borderBottom: '1px solid #333' }}
              onMouseEnter={e => e.currentTarget.style.background = '#333'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >{c}</div>
          ))}
        </div>
      )}
    </div>
  );
}